module.exports = __webpack_public_path__ + "static/media/whichThinnerThinnersList.cd9984f6.mp3";